export default (() => {
  const header = document.querySelector("header.header");
  const Classes = {
    light: 'header--light',
    atTop: 'header--at-top',
    up: 'header--going-up',
    down: 'header--going-down'
  };
  let state = {
    atTop: true,
    scrollDir: 'up'
  };
  let scrollTop = 0;

  const onStateUpdate = () => {
    if (state.atTop) {
      header.classList.add(Classes.atTop);
      header.classList.remove(Classes.light);
    } else {
      header.classList.remove(Classes.atTop);
      header.classList.add(Classes.light);
    }

    if (state.scrollDir === 'up') {
      header.classList.add(Classes.up);
      header.classList.remove(Classes.down);
    } else if (state.scrollDir === 'down') {
      header.classList.add(Classes.down);
      header.classList.remove(Classes.up);
    }
  };

  const setState = (newState) => {
    state = Object.assign(state, newState);
    onStateUpdate();
  };

  const checkScrollAndUpdateState = () => {
    const newState = {
      ...state
    };

    const st = window.pageYOffset || document.documentElement.scrollTop;

    if (st > scrollTop) {
      newState.scrollDir = 'down';
    } else {
      newState.scrollDir = 'up';
    }

    scrollTop = st <= 0 ? 0 : st;

    newState.atTop = st <= 15;

    setState(newState);
  };

  const setupEventListeners = () => {
    window.addEventListener("scroll", () => {
      checkScrollAndUpdateState();
    });
  };

  const init = () => {
    setupEventListeners();
    checkScrollAndUpdateState();
  };

  return {
    init,
  };
})();
